import React from 'react'
import css from './style.scss'
import api from './api'
import store from 'utils/store'
import PremiumPlans from 'components/subscriptions/modal/premium_plans'
import CheckoutForm from 'components/subscriptions/modal/checkout_form/form'
import moment from 'moment'
import Button from 'components/shared/button'
import {Plans} from '../../shared/plans'
import Invoices from './invoices'
class CurrentPlan extends React.Component{
  constructor(props){
    super(props)
    this.state={
      showCardForm:false
    }
  }
  cancelPlan=()=>{
    if(window.confirm("Are you sure?")){
      api.cancelSubscription()
    }
  }
  changeCardTrigger=()=>{
    this.setState({
      showCardForm:true,
    })
  }
  handleFormSubmit=()=>{
    this.setState({
      loading:true
    })
  }
  handleTokenCreation=(token)=>{
    api.changeCard(token).then(_=>{
      this.setState({
        showCardForm:false
      })
    }).catch(err=>{
      store.dispatch({type:"ADD_TOAST", message:err.response.data.err.message})
      this.setState({loading:false})
    })
  }
  render(){
    const PlanName=Plans[this.props.plan.plan].id.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
    return (
      <div className={css.currentPlan}>
        <p>You are currently on the <b>{PlanName}</b> plan.</p>
        {this.props.plan.status===2 && <p className={css.error}>Our attempt to charge your {this.props.plan.card.brand} card for your current subscription was declined.<br/>Update your card's details or check your card's balance to be sure to have enough funds.</p>}
        {this.props.plan.status===1 && <p>Your next billing will be {moment().to(moment(this.props.plan.willEndAt))} ({moment(this.props.plan.willEndAt).format("D MMMM YYYY")}) with your {this.props.plan.card.brand} card that ends in <b>{this.props.plan.card.last4}</b>.</p>}
        {this.state.showCardForm &&
          <CheckoutForm isChangingCard={true} onSubmit={this.handleFormSubmit} onSuccessTokenCreation={this.handleTokenCreation}/>
        }
        {!this.state.showCardForm &&
          <div>
            <div className={css.buttons}>
              <Button inline onClick={this.cancelPlan}>Cancel subscription</Button>
              <Button inline inline_primary className={css.right} onClick={this.changeCardTrigger}>Change card</Button>
            </div>
            <div className={css.upgradeAccount}>
              <h4>Need more accounts?</h4>
              <p>Upgrade today to connect up to <b>30</b> Instagram accounts.</p>
              <Button className={css.right} inline inline_primary to="/settings/upgrade">See custom plans</Button>
            </div>
          </div>
        }
        <Invoices />
      </div>
    )
  }
}

class SubscriptionSection extends React.Component{
  render(){
    if(this.props.user.subscription && this.props.user.subscription.active){
      return (
        <div className={css.subscription_section}>
          <h3>Your Current Plan</h3>
          <CurrentPlan plan={this.props.user.subscription}/>
        </div>
      )
    }else{
      return (
        <div className={css.subscription_section}>
          <h3>Upgrade your account</h3>
          <PremiumPlans settings={true}/>
        </div>
      )
    }

  }
}

export default SubscriptionSection;



// WEBPACK FOOTER //
// ./src/components/settings/subscription_section.js